import type { GameStore } from '../../store/GameStore';
import type { AudioManager } from '../../audio/AudioManager';

/**
 * Pause menu overlay — shown when Escape pressed with nothing else open.
 */
export function showPauseMenu(
  parent: HTMLElement,
  store: GameStore,
  _audio: AudioManager | null,
  onResume: () => void,
  onSave: () => void,
  onLoad: () => void,
  onQuit: () => void,
  onSettings?: () => void,
): void {
  store.dispatch({ type: 'SET_SPEED', speed: 0 });

  const overlay = document.createElement('div');
  overlay.className = 'game-ui';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:250;display:flex;align-items:center;justify-content:center;';

  const menu = document.createElement('div');
  menu.style.cssText = 'background:var(--color-bg-secondary);border:1px solid var(--border-color);border-radius:8px;padding:24px;min-width:220px;display:flex;flex-direction:column;gap:8px;text-align:center;';

  const title = document.createElement('h2');
  title.textContent = 'PAUSED';
  title.style.cssText = 'font-size:20px;margin-bottom:8px;color:var(--color-text-primary);';
  menu.appendChild(title);

  const makeBtn = (label: string, onClick: () => void, style?: string) => {
    const btn = document.createElement('button');
    btn.className = `btn${style ? ` btn--${style}` : ''}`;
    btn.textContent = label;
    btn.style.cssText = 'width:100%;padding:10px;font-size:14px;';
    btn.addEventListener('click', () => { overlay.remove(); onClick(); });
    return btn;
  };

  menu.appendChild(makeBtn('Resume', onResume, 'primary'));
  menu.appendChild(makeBtn('Save Game', onSave));
  menu.appendChild(makeBtn('Load Game', onLoad));

  if (onSettings) {
    menu.appendChild(makeBtn('Settings', onSettings));
  }

  menu.appendChild(makeBtn('Quit to Title', onQuit, 'danger'));

  // Escape to close
  const keyHandler = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      overlay.remove();
      onResume();
      document.removeEventListener('keydown', keyHandler, true);
    }
  };
  document.addEventListener('keydown', keyHandler, true);

  overlay.appendChild(menu);
  parent.appendChild(overlay);
}
